(function () {
  var ROOT_SELECTOR = '[data-featured-collection-media]';
  var CARD_SELECTOR = '[data-featured-collection-media-card]';
  var BUTTON_SELECTOR = '[data-featured-collection-media-button]';
  var RESPONSIVE_QUERY = '(max-width: 1180px)';

  function isResponsiveViewport() {
    return window.matchMedia ? window.matchMedia(RESPONSIVE_QUERY).matches : window.innerWidth <= 1180;
  }

  function collapseCards(root) {
    if (!root) return;
    root.querySelectorAll(CARD_SELECTOR + '.is-expanded').forEach(function (card) {
      card.classList.remove('is-expanded');
    });
    syncExpandedState(root);
  }

  function expandCard(root, card) {
    if (!root || !card) return;
    root.querySelectorAll(CARD_SELECTOR + '.is-expanded').forEach(function (candidate) {
      candidate.classList.toggle('is-expanded', candidate === card);
    });
    if (!card.classList.contains('is-expanded')) {
      card.classList.add('is-expanded');
    }
    syncExpandedState(root);
  }

  function syncExpandedState(root) {
    if (!root) return;
    root.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      var card = button.closest(CARD_SELECTOR);
      button.setAttribute('aria-expanded', card && card.classList.contains('is-expanded') ? 'true' : 'false');
    });
  }

  function isInteractiveButton(button) {
    return !!(button && !button.disabled && !button.classList.contains('is-soldout'));
  }

  function addFeaturedCollectionItem(button) {
    if (button.dataset.requiresSellingPlan === 'true') {
      if (button.dataset.productUrl) window.location.assign(button.dataset.productUrl);
      return true;
    }
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || !window.AxiomStandardStorefront || typeof window.AxiomStandardStorefront.addLines !== 'function') return false;

    var properties = {};
    if (button.dataset.manualPreorder === 'true') {
      properties[button.dataset.preorderPropertyName || '_manual_preorder'] = button.dataset.preorderPropertyValue || 'true';
    }
    if (window.AxiomAddToCartAnimation) {
      window.AxiomAddToCartAnimation.play({
        button: button,
        imageUrl: button.dataset.atcAnimationImage || '',
        mode: 'quick'
      });
    }
    window.AxiomStandardStorefront.addLines({
        id: variantId,
        quantity: parseInt(button.getAttribute('data-quantity') || '1', 10) || 1,
        properties: properties,
    }, {
      target: button.closest('form') || button,
      source: 'featured-collection-with-media'
    }).catch(function () {});

    return true;
  }

  function bind(root) {
    if (!root || root.dataset.featuredCollectionMediaBound === 'true') return;
    root.dataset.featuredCollectionMediaBound = 'true';
    syncExpandedState(root);

    if (window.matchMedia) {
      var mediaQuery = window.matchMedia(RESPONSIVE_QUERY);
      var handleViewportChange = function (event) {
        if (event.matches) return;
        collapseCards(root);
      };

      if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', handleViewportChange);
      } else if (typeof mediaQuery.addListener === 'function') {
        mediaQuery.addListener(handleViewportChange);
      }
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest(BUTTON_SELECTOR);
      if (!button || !root.contains(button)) return;

      var card = button.closest(CARD_SELECTOR);
      if (!card || !isResponsiveViewport() || !isInteractiveButton(button)) return;

      if (!card.classList.contains('is-expanded')) {
        event.preventDefault();
        event.stopPropagation();
        expandCard(root, card);
        return;
      }

      if (button.hasAttribute('data-quick-view')) {
        window.requestAnimationFrame(function () {
          collapseCards(root);
        });
      }
    });

    root.addEventListener('submit', function (event) {
      var button = event.submitter && event.submitter.matches(BUTTON_SELECTOR)
        ? event.submitter
        : event.target.querySelector(BUTTON_SELECTOR);

      var card = button ? button.closest(CARD_SELECTOR) : null;

      if (isResponsiveViewport() && card && isInteractiveButton(button) && !card.classList.contains('is-expanded')) {
        event.preventDefault();
        expandCard(root, card);
        return;
      }

      if (!button || button.disabled || button.classList.contains('is-soldout')) return;
      if (button.dataset.requiresSellingPlan === 'true') {
        event.preventDefault();
        collapseCards(root);
        if (button.dataset.productUrl) window.location.assign(button.dataset.productUrl);
        return;
      }
      if (!window.Axiom || window.Axiom.cartType !== 'drawer') {
        collapseCards(root);
        return;
      }

      event.preventDefault();
      addFeaturedCollectionItem(button);
      collapseCards(root);
    });

  }

  function init(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('click', function (event) {
    if (!isResponsiveViewport()) return;
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (root.contains(event.target)) return;
      collapseCards(root);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(ROOT_SELECTOR).forEach(collapseCards);
  });
})();
